import { gsap } from 'gsap';

class FaqAccordion {
    constructor(element) {
        this.element = element;
        this.items = this.element.querySelectorAll('.faq-item');
        this.activeItem = null;

        this.init();
    }

    init() {
        this.items.forEach(item => {
            const question = item.querySelector('.faq-question');
            question.addEventListener('click', () => this.toggleItem(item));
        });
    }

    toggleItem(item) {
        const answer = item.querySelector('.faq-answer');
        const icon = item.querySelector('.faq-icon');
        const isOpening = !item.classList.contains('active');

        // Close currently active item if it exists and is not the one being clicked
        if (this.activeItem && this.activeItem !== item) {
            this.closeItem(this.activeItem);
        }

        if (isOpening) {
            this.openItem(item, answer, icon);
            this.activeItem = item;
        } else {
            this.closeItem(item, answer, icon);
            this.activeItem = null;
        }
    }

    openItem(item, answer, icon) {
        item.classList.add('active');
        gsap.to(answer, {
            maxHeight: answer.scrollHeight,
            duration: 0.5,
            ease: 'power3.inOut'
        });
        icon.classList.add('active');
    }

    closeItem(item, answer = null, icon = null) {
        if (!answer) answer = item.querySelector('.faq-answer');
        if (!icon) icon = item.querySelector('.faq-icon');

        item.classList.remove('active');
        gsap.to(answer, {
            maxHeight: 0,
            duration: 0.5,
            ease: 'power3.inOut'
        });
        icon.classList.remove('active');
    }
}

export function initFaqAccordions() {
    const accordions = document.querySelectorAll('.faq-accordion');
    accordions.forEach(accordion => {
        new FaqAccordion(accordion);
    });
}
